'use strict';

var React = require('react');

var SvgMetaobjectMinor = function SvgMetaobjectMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 6.5v-1.5a1 1 0 0 1 1-1h2.5a1 1 0 0 1 1 1v1.5h.5a1 1 0 0 1 1 1v3.5h1.5v-1.5a1 1 0 0 1 1-1h2.5a1 1 0 0 1 1 1v1.5h.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1v-4c0-.086.01-.17.031-.25a1.002 1.002 0 0 1-.031-.25v-4a1 1 0 0 1 1-1h.5Zm1.5 0v-1h1.5v1h-1.5Zm-1.5 1.5v3h4.5v-3h-4.5Zm10.5 3h-1.5v-1h1.5v1Zm1.5 1.5v3h-12v-3h12Z"
  }));
};
SvgMetaobjectMinor.displayName = "MetaobjectMinor";

exports.SvgMetaobjectMinor = SvgMetaobjectMinor;
